import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import Header from '@/components/Header';
import MobileHeader from '@/components/mobile/MobileHeader';
import MobileBottomNav from '@/components/mobile/MobileBottomNav';
import Footer from '@/components/Footer';
import { ScorekeeperApplicationSystem } from '@/components/scorekeeper/ScorekeeperApplicationSystem';
import { ScorekeeperAssignmentInterface } from '@/components/venue/ScorekeeperAssignmentInterface';
import { useAuthenticatedUser } from '@/hooks/useAuthenticatedUser';
import { ClipboardCheck, Send, Users } from 'lucide-react';

export default function ScorekeeperApplicationsNew() {
  const { user } = useAuthenticatedUser();

  if (!user) {
    return (
      <div className="min-h-screen bg-background">
        <div className="hidden md:block">
          <Header />
        </div>
        <div className="md:hidden">
          <MobileHeader />
        </div>
        <div className="container mx-auto px-4 py-8 pt-20">
          <Card>
            <CardContent className="p-8 text-center">
              <p className="text-muted-foreground">Please log in to view scorekeeper applications</p>
            </CardContent>
          </Card>
        </div>
        <div className="md:hidden">
          <MobileBottomNav />
        </div>
        <div className="hidden md:block">
          <Footer />
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-background">
      <div className="hidden md:block">
        <Header />
      </div>
      <div className="md:hidden">
        <MobileHeader />
      </div>
      
      <div className="container mx-auto px-4 py-8 pt-20 pb-24 md:pb-8">
        <div className="space-y-6">
          <div>
            <h1 className="text-3xl font-bold">Scorekeeper Management</h1>
            <p className="text-muted-foreground">
              Apply for scorekeeper positions and manage applications
            </p>
          </div>

          {/* Overview Cards */}
          <div className="grid gap-4 md:grid-cols-3">
            <Card>
              <CardContent className="p-6">
                <div className="flex items-center gap-4">
                  <Send className="h-8 w-8 text-primary" />
                  <div>
                    <p className="text-2xl font-bold">-</p>
                    <p className="text-sm text-muted-foreground">Applications Sent</p>
                  </div>
                </div>
              </CardContent>
            </Card>

            <Card>
              <CardContent className="p-6">
                <div className="flex items-center gap-4">
                  <ClipboardCheck className="h-8 w-8 text-primary" />
                  <div>
                    <p className="text-2xl font-bold">-</p>
                    <p className="text-sm text-muted-foreground">Games Assigned</p>
                  </div>
                </div>
              </CardContent>
            </Card>

            <Card>
              <CardContent className="p-6">
                <div className="flex items-center gap-4">
                  <Users className="h-8 w-8 text-primary" />
                  <div>
                    <p className="text-2xl font-bold">-</p>
                    <p className="text-sm text-muted-foreground">Games Available</p>
                  </div>
                </div>
              </CardContent>
            </Card>
          </div>

          {/* Application Management */}
          <Tabs defaultValue="apply" className="space-y-6">
            <TabsList className="grid w-full grid-cols-2">
              <TabsTrigger value="apply">Apply for Games</TabsTrigger>
              <TabsTrigger value="manage">Manage Applications</TabsTrigger>
            </TabsList>

            <TabsContent value="apply" className="space-y-6">
              <ScorekeeperApplicationSystem />
            </TabsContent>

            <TabsContent value="manage" className="space-y-6">
              <Card>
                <CardHeader>
                  <CardTitle>Review Scorekeeper Applications</CardTitle>
                </CardHeader>
                <CardContent>
                  <ScorekeeperAssignmentInterface gameId="" />
                </CardContent>
              </Card>
            </TabsContent>
          </Tabs>
        </div>
      </div>

      <div className="md:hidden">
        <MobileBottomNav />
      </div>
      <div className="hidden md:block">
        <Footer />
      </div>
    </div>
  );
}